// Only register on http/https — skips Capacitor (capacitor://) and file:// contexts
const isEligible =
  'serviceWorker' in navigator &&
  window.location.protocol.startsWith('http');

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  /^127(?:\.\d+){3}$/.test(window.location.hostname);

export function register() {
  if (!isEligible) return;
  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
    if (isLocalhost) {
      checkWorkerFile(swUrl);
    } else {
      registerWorker(swUrl);
    }
  });
}

function registerWorker(swUrl) {
  navigator.serviceWorker.register(swUrl).then(reg => {
    reg.onupdatefound = () => {
      const worker = reg.installing;
      if (!worker) return;
      worker.onstatechange = () => {
        if (worker.state === 'installed' && navigator.serviceWorker.controller) {
          console.log('[BandConnect] New version available — reload to update.');
        }
      };
    };
  }).catch(err => console.error('[BandConnect] SW registration failed:', err));
}

function checkWorkerFile(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } }).then(res => {
    const isJs = (res.headers.get('content-type') || '').includes('javascript');
    if (res.status === 404 || !isJs) {
      navigator.serviceWorker.ready
        .then(reg => reg.unregister())
        .then(() => window.location.reload());
    } else {
      registerWorker(swUrl);
    }
  }).catch(() => console.log('[BandConnect] No connection — running offline.'));
}

export function unregister() {
  if (!isEligible) return;
  navigator.serviceWorker.ready
    .then(reg => reg.unregister())
    .catch(err => console.error('[BandConnect] SW unregister failed:', err));
}
